/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const whatsAppTemplateAnalyticsDataSchema = z.object({
	templateId: z.string().nullable(),
	templateName: z.string().nullable(),
	sentCount: z.number(),
	deliveredCount: z.number(),
	readCount: z.number(),
	failedCount: z.number(),
})

export type WhatsAppTemplateAnalyticsDataSchema = z.infer<typeof whatsAppTemplateAnalyticsDataSchema>
